/* 产品列表 tabel */
<template>
  <div class="modify-item-record">
    <Table
      :columns="columns"
      :data="lists"
      disabled-hover
      class="render-extend-style"
      tooltip
    >
      /** 定制要求 */
      <template slot-scope="{ row }" slot="remark">
        <div>{{ (row.product && row.product.remark) || "暂无" }}</div>
      </template>
      /** 落地参考价 */
      <template slot-scope="{ row }" slot="unitPrice">
        <div>
          <span>{{ row.unitPrice | currency("¥", "2") }}</span>
        </div>
      </template>
      /** 原数量 */
      <template slot-scope="{ row }" slot="qtr">
        <div>{{ row.originNum }}</div>
      </template>
      /** 小计*/
      <template slot-scope="{ row }" slot="total">
        <div>{{ ((row.originNum + row.changeQtr) * row.unitPrice) | currency("¥", "2") }}</div>
      </template>
      /** 增减数量*/
      <template slot-scope="{ row }" slot="changeQtr">
        <span v-if="row.changeQtr && row.changeQtr != 0">{{
          row.changeQtr
        }}</span>
        <span v-else>-</span>
      </template>
      /** 本次增减费用*/
      <template slot-scope="{ row }" slot="currentChangeUnitPrice">
        <div v-if="row.currentChangeUnitPrice">
          {{row.currentChangeUnitPrice | currency("¥", "2")}}
        </div>
        <div v-else>-</div>
      </template>
      <template slot-scope="{ row }" slot="createTime">
        <div v-if="row.createTime">{{ row.createTime | date }}</div>
        <div v-else>-</div>
      </template>
      <template slot-scope="{ row }" slot="confirmedTime">
        <div v-if="row.confirmedTime">{{ row.confirmedTime | date }}</div>
        <div v-else>-</div>
      </template>
    </Table>
    <!-- <tabel-expand-material :row="lists[0]"></tabel-expand-material> -->
  </div>
</template>

<script>
import Products from "@/mixins/Products";
import tabelExpandMaterial from "./table-expand-material.vue";
export default {
  mixins: [Products],
  data() {
    return {
      columns: [
        {
          title: "定制要求",
          align: "center",
          slot: "remark"
        },

        {
          type: "expand",
          width: 1,
          render: (h, params) => {
            return h(tabelExpandMaterial, {
              props: {
                row: params.row
              }
            });
          }
        },

        {
          title: "落地参考价",
          align: "center",
          slot: "unitPrice",
          width: 120
        },
        {
          title: "原数量",
          align: "center",
          slot: "qtr"
        },
        {
          title: "小计",
          align: "center",
          slot: "total"
        },
        {
          title: "当次增减数量",
          align: "center",
          slot: "changeQtr"
        },
        {
          title: "当次增补费用",
          align: "center",
          slot: "currentChangeUnitPrice"
        },
        {
          title: "创建时间",
          align: "center",
          slot: "createTime",
          width: 170
        },
        {
          title: "确定修改时间",
          align: "center",
          slot: "confirmedTime",
          width: 170
        }
      ]
    };
  },
  components: { tabelExpandMaterial },
  props: {
    lists: {
      type: [Array, String],
      default: ""
    }
  },
  methods: {
    setObjectParams(lists) {
      if (!lists || lists.length === 0) return false;
      let _acIndex = 0;
      lists.forEach(item => {
        this.$set(item, "_expanded", true);
      });
    }
  },
  watch: {
    lists:function() {
      this.setObjectParams(this.lists)
    }
  },
  created() {
    this.setObjectParams(this.lists)
  }
};
</script>

<style lang="scss">
.modify-item-record {
  margin-top: 20px;
  .render-extend-style .ivu-table-expanded-cell > div {
    margin-left: 0px !important;
    width: 1200px !important;
  }
}
</style>
